export var ArticlePublishStatus;
(function (ArticlePublishStatus) {
    ArticlePublishStatus["GENERATING"] = "GENERATING";
    ArticlePublishStatus["FAILED_GENERATE"] = "FAILED_GENERATE";
    ArticlePublishStatus["FINISH_GENERATE"] = "FINISH_GENERATE";
    ArticlePublishStatus["WAITING"] = "WAITING";
    ArticlePublishStatus["PENDING"] = "PENDING";
    ArticlePublishStatus["SUCCEED"] = "SUCCEED";
    ArticlePublishStatus["FAILED"] = "FAILED";
    ArticlePublishStatus["PAUSE"] = "PAUSE";
    ArticlePublishStatus["EXPIRES"] = "EXPIRES";
    ArticlePublishStatus["CANCEL"] = "CANCEL";
})(ArticlePublishStatus || (ArticlePublishStatus = {}));
export const getArticlePublishStatusName = {
    [ArticlePublishStatus.GENERATING]: '生成中',
    [ArticlePublishStatus.FAILED_GENERATE]: '生成失败',
    [ArticlePublishStatus.FINISH_GENERATE]: '生成完成',
    [ArticlePublishStatus.WAITING]: '待发布',
    [ArticlePublishStatus.PENDING]: '发布中',
    [ArticlePublishStatus.SUCCEED]: '发布成功',
    [ArticlePublishStatus.FAILED]: '发布失败',
    [ArticlePublishStatus.PAUSE]: '暂停',
    [ArticlePublishStatus.EXPIRES]: '已过期',
    [ArticlePublishStatus.CANCEL]: '已取消',
};
export var SiteCreateType;
(function (SiteCreateType) {
    SiteCreateType["TEMPLATE_SITE"] = "TEMPLATE_SITE";
    SiteCreateType["AI_SITE"] = "AI_SITE";
    SiteCreateType["AI_EMPLOYEE_SITE"] = "AI_EMPLOYEE_SITE";
    SiteCreateType["AI_EXPERT_SITE"] = "AI_EXPERT_SITE";
    SiteCreateType["AI_TEMPLATE_SITE"] = "AI_TEMPLATE_SITE";
})(SiteCreateType || (SiteCreateType = {}));
export var UserIdentificationSourceBusinessType;
(function (UserIdentificationSourceBusinessType) {
    UserIdentificationSourceBusinessType["BAIDU"] = "BAIDU";
    UserIdentificationSourceBusinessType["BAIDU_SPIDER"] = "BAIDU_SPIDER";
    UserIdentificationSourceBusinessType["EDM"] = "EDM";
    UserIdentificationSourceBusinessType["FACEBOOK"] = "FACEBOOK";
    UserIdentificationSourceBusinessType["GOOGLE"] = "GOOGLE";
    UserIdentificationSourceBusinessType["MAIL"] = "MAIL";
    UserIdentificationSourceBusinessType["OTHER"] = "OTHER";
    UserIdentificationSourceBusinessType["WHATSAPP"] = "WHATSAPP";
})(UserIdentificationSourceBusinessType || (UserIdentificationSourceBusinessType = {}));
